export default __webpack_public_path__ + "static/media/599Notice.3d387f35.png";